const getters = {
  // orgs: state => state.organizations.list,
  sysRoleMenus: state => state.sysRoleMenus.list,
  lockerStatusList: state => state.lockerList.lockerStatusList,
  lockerSizeList: state => state.lockerList.lockerSizeList,
  centerList: state => state.lockerList.centerList,
  course: state => state.course.list,
  program: state => state.program.list,
  programPrice: state => state.programPrice.list,
  courseItems: state => state.course.items,
  programItems: state => state.program.items,
  programPriceItems: state => state.programPrice.items,
  lockerList: state => state.lockerList.lockerList,
  courseItemList: state => state.courseItemList.courseItemList,
  courseItemMachineList: state => state.courseItemList.courseItemMachineList,
  courseItemCategoryList: state => state.courseItemList.courseItemCategoryList,
  unitList: state => state.courseItemList.unitList,
  newMember: state => state.order.newMember,
  promotionItems: state => state.promotion.list,
  orderTypeItems: state => state.orderType.list,
  studentList: state => state.users.studentList,
  coachList: state => state.users.coachList,
  orderInfo: state => state.order.orderInfo,
  centerItems: state => state.center.items,
  sysRoleList: state => state.sysRole.list,
  loading: state => state.system.loading,
  sysRoleCoachList: state => state.sysRole.coachList,
}
export default getters
